const hero = {
	el: {
		heroArticle: document.querySelector('.hero-article'),
		heroArticleHeading: document.querySelector('.hero-article__heading'),
		heroArticlePreHeading: document.querySelector('.hero-article__preheading'),
		heroArticleInfo: document.querySelector('.hero-article__info'),
		heroArticleContainer: document.querySelector('.hero-article__container')
	},

	vars: {
		extraLargeAndUp: window.matchMedia('(min-width: 80em)')
	},

	fxHeroInfoSpacing() {
		if (!this.el.heroArticle) return

		!this.el.heroArticleContainer ? this.el.heroArticle.style.paddingBottom = 0 : ''

		if (!this.el.heroArticleHeading) return

		const preaheadingOuterHeight = this.el.heroArticlePreHeading ? this.el.heroArticlePreHeading.offsetHeight + parseInt(window.getComputedStyle(this.el.heroArticlePreHeading).getPropertyValue('margin-bottom')) : 0,
			headingOuterHeight = this.el.heroArticleHeading.offsetHeight + parseInt(window.getComputedStyle(this.el.heroArticleHeading).getPropertyValue('margin-bottom')),
			totalHeadingHeight = headingOuterHeight + preaheadingOuterHeight

		this.vars.extraLargeAndUp.matches ? this.el.heroArticleInfo.style.paddingTop = `${totalHeadingHeight/10}rem` : ''
	},

	init() {
		this.fxHeroInfoSpacing()
	}
}

hero.init()